import { render, staticRenderFns } from "./AbilityScores.vue?vue&type=template&id=5d138b3a&scoped=true&"
import script from "./AbilityScores.vue?vue&type=script&lang=js&"
export * from "./AbilityScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d138b3a",
  null
  
)

export default component.exports